import { moduleFactory } from "@/factories/module";
import { buildAppWindowUrl } from "@/modules/window/build-url";
import { _getCurrentWindowUrlSearchParams } from "@/modules/window/url-params";
import { getWindowGoogleIdentityOAuthRedirectUrl } from "@/modules/window/google-redirect";
import { forceHardReloadWindow, forceReloadWindow } from "@/modules/window/reload";
import {
  navigateToExternalWindowUrl,
  navigateToInternalWindowUrl,
  navigateToWindowUrlAndRefresh,
  openWindowUrlInNewTab,
} from "@/modules/window/navigation";
import { getWindowOrigin } from "@/modules/window/origin";

export const windowModule = moduleFactory.create({
  currentUrlSearchParams: _getCurrentWindowUrlSearchParams,
  buildUrl: buildAppWindowUrl,
  getOrigin: getWindowOrigin,
  forceReload: forceReloadWindow,
  forceHardReload: forceHardReloadWindow,
  navigateToInternal: navigateToInternalWindowUrl,
  navigateToExternal: navigateToExternalWindowUrl,
  navigateToAndRefresh: navigateToWindowUrlAndRefresh,
  openInNewTab: openWindowUrlInNewTab,
  getGoogleIdentityOAuthRedirectUrl: getWindowGoogleIdentityOAuthRedirectUrl,
});
